import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/parametrizacao`

    return {
        autocomplete(queryParams = {}) {

            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParams)}`)
        },
        index() {
            return repository.get(`${baseUrl}`);
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        getOcupacoes(queryParms) {

            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(queryParms)}`)
        },
    }
}